export enum ContactHfsLabels {
  Email = 'Email',
  Phone = 'Mobile Phone Number',
  FirstName = 'First Name',
  LastName = 'Last Name',
  Message = 'Message',
}
